import { DateTime } from 'luxon'

export const sortMessages = (a: any, b: any): number =>
  sortDates(DateTime.fromISO(a.updatedAt), DateTime.fromISO(b.updatedAt))

export const sortThreadMessages = (a: any, b: any): number =>
  sortDates(DateTime.fromISO(a.createdAt), DateTime.fromISO(b.createdAt))

const sortDates = (a: DateTime, b: DateTime): number => {
  if (a.diff(b, 'seconds').seconds < 0) {
    return -1
  }
  if (a.diff(b, 'seconds').seconds > 0) {
    return 1
  }
  return 0
}

export const makeThreadIdParam = (s: string) => s.replace('#', 'HASH')

export const parseThreadIdParam = (s: string) => s.replace('HASH', '#')

// Extract clean thread ID for API calls (removes #EVENT, #USER, etc. suffixes)
export const getCleanThreadId = (threadId: string): string => {
  return threadId.split('#')[0]
}
